import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
    FormControl,
    Select,
    MenuItem
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { errorAlert, successAlert } from 'ui-component/Toasts';
import { axiosInstance } from 'utils/axios';
import { selectCurrentToken } from 'features/auth/authSlice';

const BatchUpdateAmbassadorDeposit = ({ row, fetchAmbassadorDepositIncentives, status }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    const [fromWithdrawalID, setFromWithdrawalID] = useState(null);
    const [toWithdrawalID, setToWithdrawalID] = useState(null);
    const [totalAmount, setTotalAmount] = useState(null);
    const [totalRows, setTotalRows] = useState(null);

    const [newStatusID, setNewStatusID] = useState(null);

    const fetchConfirmation = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get(`/BatchUpdate/PendingAmbassadorDepositIncentive/IDRange/Confirmation?maxID=${row.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setFromWithdrawalID(res.data.fromWithdrawalID);
                setToWithdrawalID(res.data.toWithdrawalID);
                setTotalAmount(res.data.totalAmount);
                setTotalRows(res.data.totalRows);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const batchUpdate = async () => {
        if (!fromWithdrawalID || !toWithdrawalID) return;
        if (!newStatusID) {
            errorAlert('Please select new status.');
            return;
        }
        setLoading(true);
        try {
            const res = await axiosInstance.post(
                `/BatchUpdate/PendingAmbassadorDepositIncentive/IDRange`,
                {
                    fromWithdrawalID,
                    toWithdrawalID,
                    oldStatusID: 1, // Pending
                    newStatusID
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.status === 200) {
                successAlert('Success!');
                fetchAmbassadorDepositIncentives();
                setOpen(false);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            errorAlert('Something went wrong.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (open) {
            fetchConfirmation();
        }
    }, [open]);

    return (
        <>
            <Button variant="outlined" onClick={() => setOpen(true)} fullWidth>
                Batch Update
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
                <DialogTitle fontSize={16}>{'Please Confirm'}</DialogTitle>
                {loading ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            paddingY: '20px'
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <DialogContent>
                        <Box sx={{ display: 'flex', gap: '3px', flexDirection: 'column', marginBottom: '20px' }}>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                New Status :
                            </Typography>
                            <FormControl fullWidth>
                                <Select value={newStatusID} onChange={(e) => setNewStatusID(e.target.value)} sx={{ minWidth: '200px' }}>
                                    {status.map((s) => {
                                        return (
                                            <MenuItem key={s.id} value={s.id}>
                                                {s.name}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </Box>
                        <DialogContentText>
                            {`Update From ID ${fromWithdrawalID} to ID ${toWithdrawalID}, Total ${totalRows} Rows, Total Amount ${totalAmount}`}
                        </DialogContentText>
                    </DialogContent>
                )}
                <DialogActions>
                    <Button color="error" onClick={() => setOpen(false)} disabled={loading}>
                        Cancel
                    </Button>
                    <Button color="secondary" onClick={() => batchUpdate()} disabled={loading}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default BatchUpdateAmbassadorDeposit;
